@if(isPlanEnding) {
<div>
  {{ expirationMessage }}
  @if(canManageAccount) {
    <a [routerLink]="['/subscription', 'new']">Subscribe Now</a>
  }
</div>
}
